export enum DMSFormat {
  WITH_UNITS,
  ICAO
}
